import React, { useEffect, useState } from "react";
// import logo from "../../assets/logo/logo.svg";
import logo from "../../assets/logo/beelogo.png"
import { useContext } from "react";
import { AppContext } from "component/context";
import { isMobile } from "react-device-detect";
import { NotificationManager } from "react-notifications";

const Header = () => {
  const [direction, setDirection] = useState("");
  const [fun, setFun] = useContext(AppContext);
  const [button, setButton] = useState("save");
  const [divRef, setDivRef] = useState("");

  useEffect(() => {
    setTimeout(() => {
      const body = document.body;
      const direc = getComputedStyle(body).direction;
      setDirection(direc)
    }, 100)
  })

  useEffect(() => {
    if (window.location.href.indexOf("placeholder") > -1) {
      setButton("placeholder");
    }

  }, []);

  useEffect(() => {
    let signDiv = document.querySelectorAll(".notsign");
    setDivRef(signDiv);
  }, [fun]);

  const scroll = () => {
    let signDiv = document.querySelectorAll(".notsign");
    if (signDiv.length) {
      signDiv[0].parentNode.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
      signDiv[0].style =
        "box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px; width:100%; height:100%; direction:rtl";
      NotificationManager.warning("חסרות כמה חתימות");
    } else {
      NotificationManager.success("סיימתם לחתום על המסמך, לחצו על שמור כדי לשלוח אותו אלינו");
    }
  };

  return (
    <div className="sticky" id="navbar">
      <div className="navbar-child d-flex jc-between ai-center p-15">
        <div>
          <img src={logo} width={` ${isMobile ? "150" : "100"} `} alt="logo" />
        </div>
        <div className="color-white px-15">
          {button === "save" ? (
            <button
              onClick={divRef.length ? scroll : () => fun?.onSavePdf()}
              className={` ${isMobile ? "fs-20" : "fs-16"
                } bg-orange br-none py-5 fw-500 color-white br-5 px-15 cursor-pointer`}
            >
              שמירה
            </button>
          ) : (
            <div style={{ gap: "20px" }} className="d-flex">
              <button
                onClick={() => fun?.newPlaceHolder()}
                className={` ${isMobile ? "fs-20" : "fs-16"
                  } bg-orange br-none py-5 fw-500 color-white br-5 px-10 cursor-pointer`}
              >
                הוסף שדה חתימה
              </button>
              <button
                onClick={() => fun?.plcHldrFun()}
                className={` ${isMobile ? "fs-20" : "fs-16"
                  } bg-orange br-none py-5 fw-500 color-white br-5 px-10 cursor-pointer`}
              >
                שמור מסמך
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="gray-color"></div>
    </div>
  );
};

export default Header;
